// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3mg7C","boxTitle":"Qualiphy_boxTitle__2HKtJ","box":"Qualiphy_box__3UCQc","toggleWrap":"Qualiphy_toggleWrap__1TfNB"};